var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 59.447 59.447",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.939,5.366H2.51C1.123,5.366,0,6.489,0,7.875s1.123,2.51,2.51,2.51h3.096v31.961c0,1.039,0.843,1.882,1.883,1.882 h18.025l-6.164,6.163c-0.734,0.736-0.734,1.926,0,2.662c0.734,0.734,1.926,0.734,2.661,0l7.476-7.475l7.949,7.95 c0.368,0.367,0.85,0.552,1.332,0.552c0.48,0,0.963-0.185,1.33-0.552c0.734-0.735,0.734-1.926,0-2.661l-6.641-6.641H51.96 c1.04,0,1.882-0.843,1.882-1.882V10.384h3.098c1.385,0,2.508-1.124,2.508-2.51S58.324,5.366,56.939,5.366z M50.078,40.464H9.369 v-30.08h40.709V40.464z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.4c29f4dbfff3db0fca8cf75f814b95fc.svg";
export { ForwardRef as ReactComponent };